import React, { FC } from 'react';
import { Load } from '../../../../types';
import { useCompanyId } from '../../../../app/agistics-context';
import { typedCreateStop } from '../../utils/typed-create-stop';
import { typedCreateLoad } from '../../utils/typed-create-load';
import { EditCreateLoad } from '../../edit-create-load/edit-create-load';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import { OrgQueryKeys } from '../../../../api/config';
import { withThroughputs } from '../../../../utils/throughput-utils';

interface Step2CreateLoadFromPreviousProps {
    load: Load;
    onBack: () => void;
    onSubmit: () => void;
}

export const Step2CreateLoadFromPrevious: FC<Step2CreateLoadFromPreviousProps> = (props) => {
    const { load, onBack, onSubmit } = props;
    const companyId = useCompanyId();
    const { data: throughputs } = useOrganizationQuery(OrgQueryKeys.throughput);

    const newStops = load.stops.map((previousStop, i) => {
        const newStop = typedCreateStop(undefined, {
            sequence: i + 1,
            type: previousStop.type,
            cargoTypeId: previousStop.cargoTypeId,
            organizationLocationId: previousStop.organizationLocationId,
            quantity: previousStop.quantity,
            weight: previousStop.weight,
            productionPlan: previousStop.productionPlan,
        });
        return newStop;
    }).map(withThroughputs(throughputs));

    const newLoad = typedCreateLoad(companyId, true, newStops);

    return (
        <EditCreateLoad
            inputLoad={newLoad}
            onSubmit={onSubmit}
            onBack={onBack}
        />
    );
};
